import React from 'react'
import Story from './story'
import DescriptionThumbnail from '../DescriptionThumbnail';

class BookmarksStory extends Story {
  constructor(props) {
    super(props);

    this.state = {
      user: props.story.entity,
      bookmark: props.story.payload[0],
      payload: props.story.payload,
    }
  }

  renderFolder(){
    switch(this.state.payload[1]){
      case undefined:
        return '';
      default:
        const folderMsg = I18n.t('jslibrary.recommendations.after_save.saved_in');
        const folder_url = this.state.payload[1].url;
        const folder = <span> {folderMsg} <a href={folder_url}>{this.state.payload[1].title}</a></span>;
        return folder;
    }
  }

  render() {
    const user = this.state.user.name;
    const count = this.state.payload.length;
    const caption = this.captionWithEntity(I18n.t('jslibrary.stream.user_has_bookmarked', { user, count }), this.state.user);
    const bookmark = this.state.bookmark;

    return (
      <div className="afd-story" data-insights-category="myad-feed" data-insights-label="bookmark-story" data-insights-value={bookmark.url}>
        <p className="afd-story__caption">{caption} {this.renderFolder()}</p>
        <DescriptionThumbnail title={bookmark.title} link={bookmark.url} thumbnail={bookmark.image}/>
      </div>
    )
  }
}

export default BookmarksStory;